import { Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const GSOptionBody = styled.div`
  width: 688px;

  ${Typography.S.Typography} {
    align-items: center;
    display: flex;
    gap: 4px;
    margin-bottom: 16px;
  }
`;

const GSOption = styled.div`
  background-color: var(--color-bg-weaker);
  border-radius: var(--size-border-radius-md);
  padding: 24px;
`;

export { GSOption, GSOptionBody };
